'use client';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useDeviceLocation } from '#pplx/frontend/locations/useDeviceLocation.js';
import { useCallback } from 'react';
export const useAskDeviceLocation = (props = {}) => {
    const { track } = useInstrumentation();
    // `useDeviceLocation` is a shared non-ask hook whose `trackEvent` field keeps
    // the legacy `(name, data)` shape, so adapt the bridge `track` to it verbatim.
    const trackEvent = useCallback((name, data) => track({ event: name, data }), [track]);
    return useDeviceLocation({
        ...props,
        trackEvent,
    });
};
//# sourceMappingURL=useAskDeviceLocation.js.map